var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPillRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 402,
    viewBox: "0 0 402 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7955 250.799C-6.93178 223.072 -6.93183 178.117 20.7954 150.39L150.39 20.7955C178.117 -6.93178 223.072 -6.93183 250.799 20.7954L380.394 150.39C408.121 178.117 408.121 223.072 380.394 250.799L250.799 380.394C223.072 408.121 178.117 408.121 150.39 380.394L20.7955 250.799Z",
    fill: "#FF7192"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.424 401C176.418 399.057 161.913 392.322 150.386 380.795L20.7954 251.204C6.93181 237.341 9.95398e-06 219.17 0 201H401.182C401.182 219.17 394.25 237.341 380.386 251.205L250.795 380.795C239.268 392.322 224.764 399.057 209.758 401H191.424Z",
    fill: "#FFA4B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillRed);
export default __webpack_public_path__ + "static/media/pill_red.6ac68f94fb410476a04a294d241f202b.svg";
export { ForwardRef as ReactComponent };